import { InputForm, Error, SubmitButton } from "components";
import {
  CategoryInput,
  CategoryError,
  CreateFolderInput,
  CreateFolderError,
  CreateEpisodeError,
  EpisodeInput,
} from "modules/video/components/DataType";
import { GroupError, GroupInput } from "../group/store/actionType";
import { useEffect, useState } from "react";
import { CloudUploadIcon } from "assets";

interface BaseFormProps {
  loading: boolean;
  header: string;
  handleChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleSubmit?: React.MouseEventHandler<HTMLButtonElement>;
}

interface GroupFormProps extends BaseFormProps {
  formData: GroupInput;
  error?: GroupError | null;
  handleImageFileChange?: (file: File) => void;
}

export const GroupForm: React.FC<GroupFormProps> = ({
  formData,
  handleChange,
  handleSubmit,
  error,
  loading,
  header,
  handleImageFileChange,
}) => {
  const [imagePreviewUrl, setImagePreviewUrl] = useState<string | "">("");
  useEffect(() => {
    if (formData?.image ) {
      setImagePreviewUrl(formData.image);
    }
  }, [formData?.image]);
    // const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    //   const file = e.target.files?.[0];
    //   if (file) {
    //     setImagePreviewUrl(URL.createObjectURL(file));
    //     if (handleImageFileChange) handleImageFileChange(file);
    //   }
    // };
  return (
    <form>
      <h2 className="text-xl font-bold my-3">{header}</h2>
      <div className="pb-3">
        <InputForm
          label="Group name"
          type="text"
          id="name"
          name="name"
          value={formData.name}
          onChange={handleChange}
        />
        {error?.name && <Error>{error.name}</Error>}
      </div>
      <div className="pb-3">
        <InputForm
          label="Group Description"
          type="text"
          id="description"
          name="description"
          value={formData.description}
          onChange={handleChange}
        />
        {error?.description && <Error>{error.description}</Error>}
      </div>
      <div className="pb-3">
        <InputForm
          label="Eligibility"
          type="text"
          id="eligibility"
          name="eligibility"
          value={formData.eligibility}
          onChange={handleChange}
        />
        {error?.eligibility && <Error>{error.eligibility}</Error>}
      </div>
      <div className="pb-3">
        <InputForm
          label="Button Name"
          type="text"
          id="button_name"
          name="button_name"
          value={formData.button_name}
          onChange={handleChange}
        />
        {error?.button_name && <Error>{error.button_name}</Error>}
      </div>
      <div className="pb-3">
        <InputForm
          label="Group Order"
          type="number"
          id="group_order"
          name="group_order"
          value={formData.group_order}
          onChange={handleChange}
        />
        {error?.group_order && <Error>{error.group_order}</Error>}
      </div>
      <div className="pb-3">
        <InputForm
          label="Icon"
          type="text"
          id="icon"
          name="icon"
          value={formData.icon}
          onChange={handleChange}
        />
      </div>
      <div className="mb-4">
  <label
    htmlFor="dropzone-thumbnail"
    onDrop={(e) => {
      e.preventDefault();
      e.stopPropagation();
      const file = e.dataTransfer.files?.[0];
      if (file) {
        setImagePreviewUrl(URL.createObjectURL(file));
        if (handleImageFileChange) handleImageFileChange(file);
      }
    }}
    onDragOver={(e) => e.preventDefault()}
    className="relative flex flex-col items-center justify-center w-full h-64 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100"
  >
    {imagePreviewUrl.length > 0 ? (
      <>
        <img
          src={imagePreviewUrl || ""}
          alt="group-imge"
          className="absolute inset-0 w-full h-full object-cover rounded-lg opacity-70"
        />
        <div className="z-10 flex flex-col items-center justify-center">
          <CloudUploadIcon />
          <p className="mb-2 text-sm text-white">
            <span className="font-semibold">Click to upload</span> or drag and drop
          </p>
          <p className="text-xs text-white">JPG, PNG, WebP formats</p>
        </div>
      </>
    ) : (
      <div className="flex flex-col items-center justify-center pt-5 pb-6">
        <CloudUploadIcon />
        <p className="mb-2 text-sm text-gray-500">
          <span className="font-semibold">Click to upload</span> or drag and drop
        </p>
        <p className="text-xs text-gray-500">JPG, PNG, WebP formats</p>
      </div>
    )}
    <input
      id="dropzone-thumbnail"
      type="file"
      accept="image/*"
      className="hidden"
      onChange={(e) => {
        const file = e.target.files?.[0];
        if (file) {
          setImagePreviewUrl(URL.createObjectURL(file));
          if (handleImageFileChange) handleImageFileChange(file);
        }
      }}
    />
  </label>
</div>

      <SubmitButton loading={loading} onClick={handleSubmit} />
    </form>
  );
};

interface CreateCategoryFormProps extends BaseFormProps {
  formData: CategoryInput;
  errors: CategoryError;
}

export const CreateCategoryForm: React.FC<CreateCategoryFormProps> = ({
  formData,
  handleChange,
  handleSubmit,
  errors,
  loading,
  header,
}) => (
  <form>
    <h2 className="text-xl font-bold my-3">{header}</h2>
    <div className="pb-3">
      <InputForm
        label="Name"
        type="text"
        id="name"
        name="name"
        value={formData.name}
        onChange={handleChange}
      />
      {errors.name && <Error>{errors.name}</Error>}
    </div>
    <div className="pb-3">
      <InputForm
        label="Category Order"
        type="text"
        id="category_order"
        name="category_order"
        value={formData.category_order}
        onChange={handleChange}
      />
      {errors.category_order && <Error>{errors.category_order}</Error>}
    </div>
    <div className="pb-3">
      <InputForm
        label="Description"
        type="text"
        id="description"
        name="description"
        value={formData.description}
        onChange={handleChange}
      />
      {errors.description && <Error>{errors.description}</Error>}
    </div>
    <SubmitButton loading={loading} onClick={handleSubmit} />
  </form>
);

interface CreateFolderFormProps extends BaseFormProps {
  formData: CreateFolderInput;
  formErrors: CreateFolderError;
}

export const CreateFolderForm: React.FC<CreateFolderFormProps> = ({
  formData,
  handleChange,
  handleSubmit,
  formErrors,
  loading,
  header,
}) => (
  <form>
    <h2 className="text-xl font-bold my-3">{header}</h2>
    <div className="pb-3">
      <InputForm
        label="Title"
        type="text"
        id="title"
        name="title"
        value={formData.title ?? ""}
        onChange={handleChange}
      />
      {formErrors.title && <Error>{formErrors.title}</Error>}
    </div>
    <div className="pb-3">
      <InputForm
        label="Order"
        type="number"
        id="series_order"
        name="series_order"
        value={formData.series_order}
        onChange={handleChange}
      />
      {formErrors.series_order && <Error>{formErrors.series_order}</Error>}
    </div>
    <SubmitButton loading={loading} onClick={handleSubmit} />
  </form>
);

interface SeasonFolderFormProps extends BaseFormProps {
  title: string;
  titleError?: string | null;
}
export const CreateSeasonForm: React.FC<SeasonFolderFormProps> = ({
  title,
  handleChange,
  handleSubmit,
  titleError,
  loading,
  header,
}) => (
  <form>
    <h2 className="text-xl font-bold my-3">{header}</h2>
    <div className="pb-3">
      <InputForm
        label="Title"
        type="text"
        id="title"
        name="title"
        value={title ?? ""}
        onChange={handleChange}
      />
      {titleError && <Error>{titleError}</Error>}
    </div>
    <SubmitButton loading={loading} onClick={handleSubmit} />
  </form>
);

interface CreateEpisodeFormProps extends BaseFormProps {
  formData: EpisodeInput;
  formErrors: CreateEpisodeError;
}

export const CreateEpisodeForm: React.FC<CreateEpisodeFormProps> = ({
  formData,
  handleChange,
  handleSubmit,
  formErrors,
  loading,
  header,
}) => (
  <form>
    <h2 className="text-xl font-bold my-3">{header}</h2>
    <div className="pb-3">
      <InputForm
        label="Episode"
        type="text"
        id="label"
        name="label"
        value={formData.label ?? ""}
        onChange={handleChange}
      />
      {formErrors.label && <Error>{formErrors.label}</Error>}
    </div>
    <div className="pb-3">
      <InputForm
        label="Episode Number"
        type="number"
        id="episode_number"
        name="episode_number"
        value={formData.episode_number}
        onChange={handleChange}
      />
      {formErrors.episode_number && <Error>{formErrors.episode_number}</Error>}
    </div>
    <SubmitButton loading={loading} onClick={handleSubmit} />
  </form>
);
